import React from 'react'
import CircularProgress from '../../../../../components/CircularProgress'
import TextField from '../../../../../components/FormFields/TextField'
import { ReactComponent as UploadIcon } from '../../../../../components/Icons/upload-icon.svg'
import UploadForm from './UploadForm'
import TickIcon from './TickIcon'
import FormUploadButton from './FormUploadButton'
import { callAll, hasUploadError, renderUploadError } from './utils'

import { ReactComponent as PreIcon } from '../../../../../components/Icons/key.svg'

function UploadHaciendaField({
  id,
  label,
  values,
  errors,
  touched,
  status = {},
  model,
  handleSubmit,
  handleChange,
  handleBlur,
  isSubmitting,
  submitError,
  success,
  onChangeInput,
  ...props
}) {
  const suffix = isSubmitting
    ? <CircularProgress size={20} />
    : success || status.success
      ? <TickIcon />
      : <FormUploadButton type='submit'>
          Validar <UploadIcon />
        </FormUploadButton>
  const hasError = hasUploadError('code', { errors, touched, status, submitError })

  return (
    <UploadForm onSubmit={handleSubmit}>
      <TextField
        {...props}
        label={label}
        name='code'
        id={id}
        value={values.code}
        onChange={callAll(handleChange, onChangeInput)}
        onBlur={handleBlur}
        prefix={
          <label htmlFor={id}>
            <PreIcon width='18px' />
          </label>
        }
        suffix={suffix}
        disabled={success || status.success}
        error={hasError}
        help={renderUploadError('code', { errors, touched, status, submitError })}
        forceTip
      />
    </UploadForm>
  )
}

export default UploadHaciendaField
